import { render, staticRenderFns } from "./ManageRooms.vue?vue&type=template&id=5d1631f6&scoped=true&"
import script from "./ManageRooms.vue?vue&type=script&lang=js&"
export * from "./ManageRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1631f6",
  null
  
)

export default component.exports